module.exports = __webpack_public_path__ + "media/images/icons/calendar-share-d5e7a109a46509971fb4810b9a5fd8cd.svg";